import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Tag } from 'shared/types/tag';
import { Task } from 'shared/types/task';

export type TagRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  tags: Tag[];
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Date;
};

export const TagRenderDataContext = createContext<TagRenderData | null>(null);

export const useTagRenderData = (): TagRenderData => {
  const data = useContext(TagRenderDataContext);
  if (!data) {
    throw new Error(
      'useTagRenderData must be used within a TagGroupingTasksList',
    );
  }
  return data;
};
